import { render, staticRenderFns } from "./caricamentoFile.vue?vue&type=template&id=c4b4b9dc&"
import script from "./caricamentoFile.vue?vue&type=script&lang=ts&"
export * from "./caricamentoFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports